<template>
  <div id="wrapper">
    <Nav :message="message" />
    <ReportList />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import ReportList from '@/components/dashboard/ReportList.vue'

export default {
  name: 'MyReport',
  props: ['message'],
  components: {
    Nav,
    ReportList
  }
}
</script>